import { gql } from "@apollo/client";

export const updateCompanyPolicyNudge = gql`
  mutation updateCompanyPolicyNudge($nudgeId: MongoID!, $title: String!, $description: String!) {
    CompanyPolicyNudge_Update(nudgeId: $nudgeId, title: $title, description: $description) {
        _id
    }
  }
`;
